import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TokenStorageService } from './token-storage.service';
const API_URL = environment.apiUrl + 'team-sponsors';
@Injectable({
    providedIn: 'root'
})
export class TeamSponsorsService {
    authtoken: string;
    private httpOptions;
    constructor(private http: HttpClient, private token: TokenStorageService) {
        this.authtoken = this.token.getToken();
        this.httpOptions = {
            headers: new HttpHeaders()
                .set("Content-Type", "application/json")
                .set('Authorization', `Bearer ${this.authtoken}`)
        };
    }
    getTeamSponsorsList(query): Observable<any> {
        return this.http.get(API_URL + query);
    }
    getTeamSponsorsListWithoutAuth(query): Observable<any> {
        return this.http.get(API_URL + '/v1' + query);
    }
    getTeamSponsorsDetails(id): Observable<any> {
        return this.http.get(API_URL + '/' + id);
    }
    getTeamSponsorsDetailsWithoutAuth(id): Observable<any> {
        return this.http.get(API_URL + '/v1/' + id);
    }
    updateTeamSponsors(id, data): Observable<any> {
        return this.http.put(API_URL + '/' + id, data);
    }
    addTeamSponsors(data): Observable<any> {
        return this.http.post(API_URL, data);
    }
}